import React from 'react';
import { Link } from 'react-router-dom';
import './Shared-Formatting.css';

function Article() {
  return (
    <div className="article-wrapper">
      <article className="article-container">
        <h1 className="article-title">Interpretability Race Conditions</h1>
        <div className="article-meta">
          <span>Published on: June 30th, 2025</span> | <span>Author: Isaiah Milbank</span>
        </div>
        <div className="article-content">
          <h2>TOC</h2>
          <ul>
            <li>We're currently in a slow takeoff world</li>
            <li>How interpretability could accelerate the takeoff</li>
              <ul>
                <li></li>
              </ul>
            <li></li>
            <li>How do we prioritize net positive interpretability</li>
          </ul>
          <p></p>
          
        </div>
        <footer className="article-footer">
          <p>Thanks for reading! Check out more articles in the <Link to="/articles">Articles</Link> section.</p>
        </footer>
      </article>
    </div>
  );
}

export default Article;
